<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ThePageLoading v-if="isPageLoading"></ThePageLoading>
					
					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="deleteCompanyReport" @import-event="importFile" @export-event="exportFile" :renderDelete="(companyReport.status != '' && (isAdmin || isHQStaff) && (companyReport.status == 'Created' || companyReport.status == 'Rejected'))" :renderImport="(!isViewer && (companyReport.status == 'Created' || companyReport.status == 'Rejected') ? true : false)" :renderExport="(!isViewer && companyReport.status != '' ? true : false)" :isDeleting="isDeleting" :isImporting="isImporting" :isExporting="isExporting"></ThePageHeader>

						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">
								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-3 required">
										<label class="col-form-label-title">File ID:</label>
									</div>

									<div class="col-md-6">
										<InputText v-model="companyReport.fileId" disabled />
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Company:</label>
									</div>

									<div class="col-md-6"  v-if="companyReport.status == '' || companyReport.status == null">
										<Dropdown :options="companies" optionLabel="code" optionValue="identifier" filter :filterFields="['code', 'name']" showClear :placeholder="isCompanyLoading ? ('Loading...') : '-- Please Select --'" :loading="isCompanyLoading" v-model="companyReport.company.identifier" :disabled="identifier != null" @change="onCompanyChange">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="d-flex align-items-center">
													<span class="col-md-3">{{ filterCompanyCodeByValue(slotProps.value) }}</span>
													<span class="col-md-9">{{ filterCompanyNameByValue(slotProps.value) }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
									</div>
									<div class="col-md-6" v-else>
										<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Company" v-model="companyReport.company.name" :disabled="identifier != null"/>
									</div>
								</div>
									
								
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Balance Sheet Date:</label>
									</div>

									<div class="col-md-6">
										<Calendar dateFormat="yy-mm-dd" :manualInput="true" placeholder="Balance Sheet Date" v-model="companyReport.balanceSheetDate" :disabled="identifier != null" />
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Currency:</label>
									</div>

									<div class="col-md-6">
										<Dropdown :options="currencies" optionLabel="code" optionValue="identifier" filter :filterFields="['code', 'name']" showClear placeholder="-- Please Select --" v-model="companyReport.currency.identifier" :disabled="identifier != null">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="d-flex align-items-center">
													<span class="col-md-3">{{ filterCurrencyCodeByValue(slotProps.value) }}</span>
													<span class="col-md-9">{{ filterCurrencyNameByValue(slotProps.value) }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>

											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Purpose:</label>
									</div>

									<div class="col-md-6">
										<Dropdown :options="purposes" optionLabel="name" optionValue="identifier" filter showClear placeholder="-- Please Select --" v-model="companyReport.purpose.identifier" :disabled="identifier != null" />
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3">
										<label class="col-form-label-title">Is Consolidated:</label>
									</div>

									<div class="col-md-6" style="padding: 0.5rem 1rem;">
										<Checkbox v-model="companyReport.isConsolidated" :binary="true" :disabled="identifier != null"/>
									</div>
								</div>

								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-12">
										<Divider type="solid"></Divider>
									</div>
								</div>

								<div v-if="identifier != null">
									
									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">Created By:</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.createdBy" readonly />
										</div>

										<div class="col-md-3">
											<label class="col-form-label-title">Created Date:</label>
										</div>

										<div class="col-md-3" >
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.createdDate" readonly />
										</div>
									</div>

									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">Submitted By:</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.submissionBy" readonly />
										</div>

										<div class="col-md-3">
											<label class="col-form-label-title">Submitted Date:</label>
										</div>

										<div class="col-md-3" >
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.submissionDate" readonly />
										</div>
									</div>

									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">{{ companyReport.status === 'Rejected' ? 'Rejected By:' : 'Accepted By:' }}</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReportHistory.createdBy" readonly />
										</div>

										<div class="col-md-3">
											<label class="col-form-label-title">{{ companyReport.status === 'Rejected' ? 'Rejected Date:' : 'Accepted Date:' }}</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReportHistory.createdDate" readonly />
										</div>
									</div>

									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">Status:</label>
										</div>

										<div class="col-md-3" style="padding: 0.5rem 1rem;">
											<Badge class="mr-2" :class="[companyReport.status == 'Accepted' ? 'p-badge-success' : (companyReport.status == 'Rejected' || companyReport.status == 'Cancelled' ? 'p-badge-danger' : (companyReport.status == 'Submitted' ? 'p-badge-primary' : 'p-badge-warning'))]" :value="companyReport.status"></Badge>
										</div>

										<div class="col-md-3">
											<label class="col-form-label-title">Template Version:</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.templateVersion" readonly />
										</div>
									</div>
								</div>

								<div class="row mb-3">
									<div class="d-flex col-md-9">
										<Button class="p-button-sm" :disabled="v$.companyReport.$invalid || isLoading || (identifier != null && companyReport.status != 'Created')" @click="showSaveConfirmationDialog()" label="Save" v-if="identifier == null" />
										<span class="p-1" v-if="identifier != null"></span>
										<Button class="p-button-sm p-button-warning" :disabled="isLoading || isImporting || isExporting || isDeleting" @click="checkUnsaved(1)" label="Open Sheets" v-if="identifier != null"/>
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-warning" :disabled="isLoading || isImporting || isExporting || isDeleting" @click="showSheetsCommentsDialog()" label="Comments" v-if="identifier != null"/>
										<span class="p-1"></span>
										<Button class="p-button-sm" :disabled="v$.companyReport.$invalid || isLoading || isImporting || isExporting || isDeleting || (identifier != null && companyReport.status != 'Created' && companyReport.status != 'Rejected')" :hidden="isViewer" @click="submit" label="Submit" v-if="identifier != null"/>
										<span class="p-1"></span>
										<div v-if="identifier != null && (companyReport.status == 'Submitted' || companyReport.status == 'Accepted') && ((isAdmin || isHQStaff))">
											<Button class="p-button-sm p-button-danger" :disabled="isRPKLoaded" @click="reject(companyReport, 'RPK')" label="Reject" />
											<span class="p-1"></span>
											<Button v-if="companyReport.status == 'Submitted'" class="p-button-sm p-button-success" @click="approve(companyReport, 'RPK')" label="Accept" />
											<span v-if="companyReport.status == 'Submitted'" class="p-1"></span>
										</div>										
										<Button class="p-button-sm p-button-secondary" @click="backPreviousPage" label="Cancel"/>
										<span class="p-1"></span>

										<TheLoading v-if="isLoading"></TheLoading>
									</div>
									
									<div class="col-md-3">
										<Button class="p-button-sm p-button-warning" :disabled="isLoading || isImporting || (identifier != null && companyReport.status != 'Created' && companyReport.status != 'Rejected')" :hidden="isViewer" @click="calculate(1)" label="Recalculate" v-tooltip.top="{value: 'Calculate Sheet Values'}" v-if="identifier != null" />
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-warning" :disabled="isLoading || isImporting || companyReport.isNearestThousand || (identifier != null && companyReport.status != 'Created' && companyReport.status != 'Rejected')" :hidden="isViewer" @click="nearestThousandConversion(companyReport)" label="Convert" v-tooltip.top="{value: 'Convert Nearest Thousand'}" v-if="identifier != null" />
									</div>
								</div>
								
								<div class="row mb-3" v-if="identifier != null && companyReportHistory.remarks != null && companyReportHistory.remarks != ''">
									<div class="col-md-12">
										<InlineMessage severity="warn" class="d-block">Remarks: <pre class="p-4">{{ companyReportHistory.remarks }}</pre></InlineMessage>
									</div>
								</div>

								<div class="row mb-3" v-if="identifier != null && isRPKLoaded">
									<div class="col-md-12">
										<InlineMessage severity="info" class="d-block">RPK is currenly loaded in a CWK: {{ loadedInFileId }}</InlineMessage>
									</div>									
								</div>
							</div>
						</div>
						
						
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
	
	<Dialog v-model:visible="isShowConfirmation" header="Create from Previous Report" modal :style="{ width: '50vw' }">
		<p>
			Do you want to create a new company report from previous report?
		</p>

		<DataTable class="p-datatable p-component align-middle mb-0 w-12" :value="previousReports" v-model:selection="selectedReport" paginator :rows="5">
			<Column style="width: 5%" selectionMode="single"></Column>
			<Column style="width: 35%;" field="fileId" header="File ID"></Column>
			<Column style="width: 30%;" field="date" header="Balance Sheet Date"></Column>
			<Column style="width: 30%; text-align: center" header="Is Consolidated">
				<template #body="slotProps">
					<i class="pi pi-check text-success" v-if="slotProps.data.isConsolidated" />
					<i class="pi pi-times text-danger" v-else />
				</template>
			</Column>
		</DataTable>
            
		<template #footer>
			<Button label="No" icon="pi pi-times" @click="save(false)" text />
			<span class="p-1"></span>
			<Button label="Yes" icon="pi pi-check" @click="save(true)" :disabled="v$.selectedReport.$invalid || isLoading"  />
		</template>
	</Dialog>

	<Dialog v-model:visible="isShowUnsavedConfirmation" header="Recover Unsaved Changes" modal :style="{ width: '40vw' }">
		<p v-if="isViewer">
            Any data entered by you (as a viewer) will not be saved or processed
        </p>
        <p v-else>
			Unsaved changes detected and available to recovery. Would you like to recover these changes now?
		</p>
            
		<template #footer>
			<Button label="No" icon="pi pi-times" @click="sheets(1, false, null)" text />
			<Button label="Yes" icon="pi pi-check" @click="sheets(1, true, null)" :hidden="isViewer" />
		</template>
	</Dialog>
	
	<Dialog v-model:visible="isShowGlobalFilterConfirmation" header="Filter in use" modal :style="{ width: '40vw' }">
        <p>
			Click “No” to clear the Filter and view all companies.<br>
            Click “Yes” to view <b>{{ selectedGlobalFilterName }}</b> and Subsidiary Companies.
		</p>
            
		<template #footer>
			<Button label="No" icon="pi pi-times" @click="proceedWithResetGlobalFilter" text />
			<Button label="Yes" icon="pi pi-check" @click="proceedGlobalFilterWarning" />
		</template>
	</Dialog>
	
	<Dialog v-model:visible="isCalculating" header="Calculating" modal :style="{ width: '40vw' }" :closable="false">
		<p>
			The system is calculating, please do not refresh the page or close the window while calculating.
		</p>
									
		<template #footer>
			<TheLoading v-if="isCalculating"></TheLoading>
		</template>
	</Dialog>

	<Dialog v-model:visible="isShowImportErrorNotification" header="Import Error Notification" modal :style="{ width: '60vw' }" :closable="false">
		<p>
			Import file {{ importFileName }} completed with {{ importErrors.length }} issue(s). The rows listed below were skipped; all other rows were imported.
		</p>

		<DataTable class="p-datatable p-component align-middle mb-0 w-12" :value="importErrors" paginator :rows="10">
			<Column style="width: 6%" field="" header="#" class="p-template-column-number">
				<template #body="slotProps">
					<div class="d-flex">
						<span class="p-row-title-text">{{ slotProps.index + 1 }}</span>
					</div>
				</template>
			</Column>			
			<Column style="width: 38%;" field="sheetName" header="Sheet Name"></Column>
			<Column style="width: 10%;" field="importValue" header="Value"></Column>
			<Column style="width: 10%;" field="cell" header="Cell"></Column>
			<Column style="width: 36%;" field="errorMessage" header="Message"></Column>
		</DataTable>
            
		<template #footer>
			<div class="align-items-center my-2" style="color: red;">Please download the error list to review the issues.</div>
			<Button label="Download" icon="pi pi-download" @click="downloadImportError()" text />
			<Button label="Ok" icon="pi pi-times" @click="loadSheetWithImportFile()" />
		</template>
	</Dialog>

    <Dialog v-model:visible="dialogRemark.visible" header="Confirmation" modal :style="{width: '40vw'}">
		<div>
			<div class="row">
				<div class="col-md-12 d-flex">
					<i class="mr-3 align-self-center" :class="dialogRemark.icon != null && dialogRemark.icon != '' ? dialogRemark.icon : 'pi pi-exclamation-triangle'" style="font-size: 1.5rem;" />
					<span>{{ dialogRemark.message }}</span>
				</div>

				<div class="col-md-12 mt-3" v-if="dialogRemark.withRemarks">
					<Textarea v-model="dialogRemark.remarks" :autoResize="true" rows="5" cols="30" maxlength="255" placeholder="Remarks" autofocus />
				</div>

			</div>
		</div>

		<template #footer>
			<div class="d-flex justify-content-end">
				<TheLoading v-if="this.dialogRemark.loading"></TheLoading>

				<Button class="p-button-text p-button-sm" label="No" icon="pi pi-times" @click="closeDialogRemark" />
				<Button class="p-button-sm" label="Yes" icon="pi pi-check" @click="onConfirmDialogRemark" :disabled="(dialogRemark.status == 'Rejected' && dialogRemark.remarks == '')"/>
			</div>
		</template>
	</Dialog>

	<TheSheetsCommentsDialog ref="sheetsCommentsDialog"></TheSheetsCommentsDialog>

	<TheSheetsDialog ref="sheetDialog" :identifier="dialog.identifier" :name="dialog.companyName" :companyId="dialog.companyId" :type="'rpk'" :balanceSheetDate="dialog.balanceSheetDate == null ? null : formatToDate(dialog.balanceSheetDate)" :currencyCode="dialog.currencyCode" :purpose="dialog.purpose" :id="dialog.id" :templateIndex="dialog.templateIndex" :status="dialog.status" :visible="dialog.visible" :loading="dialog.loading" :isUnsaved="dialog.isUnsaved" :isConsolidated="dialog.isConsolidated" :reportSheets="dialog.companyReportSheets" :isNearestThousandPreview="isNearestThousandPreview" @save="updateSheets" @autoSave="updateSheetCached" @deleteCached="deleteSheetCached" @cancel="closeDialog"></TheSheetsDialog>
</template>

<script lang="ts">
	import {defineComponent} from "vue";
	import {useRoute} from "vue-router";
	import store from "@/store";
	
	import companyApi from "@/api/company-api";
	import currencyApi from "@/api/currency-api";
	import purposeApi from "@/api/purpose-api";
	import companyReportApi from "@/api/companyreport-api";
	import companyReportHistoryApi from "@/api/companyreporthistory-api";
	import companyReportSheetApi from "@/api/companyreportsheet-api";
	import companyReportSheetTemplateApi from "@/api/companyreportsheettemplate-api";
	import approvalApi from "@/api/approval-api";
	
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	import textUtilMixin from "@/mixin/utils/text-utils";
	import roleMixin from "@/mixin/role";
	import severityMixin from "@/mixin/severity";
	import statusMixin from "@/mixin/status";
	import formulaMixin from "@/mixin/formula";
    import excelUtils from "@/mixin/utils/excel-utils";

	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheSheetsDialog from "@/components/TheSheetsDialog.vue";
	import TheSheetsCommentsDialog from "@/components/TheSheetsCommentsDialog.vue";

	import useVuelidate from "@vuelidate/core"
	import {required, requiredIf} from "@vuelidate/validators"	

	export default defineComponent({
		mixins: [dateUtilsMixin, textUtilMixin, roleMixin, severityMixin, statusMixin, formulaMixin, excelUtils],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
			TheSheetsDialog,
			TheSheetsCommentsDialog
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				companyReportSheets: [] as any[],
				companyReport: {identifier: null, fileId: null, company: {identifier: null as any, name: '', currency: {identifier: null as any, name: null}}, balanceSheetDate: null as any, currency: {identifier: null, code: ''}, purpose: {identifier: null, name: ''}, consoGroup: {identifier: null as any, name: ''}, isConsolidated: false, isPreviousConsolidated: null, id: 0.0, createdUserId: '', createdBy: '', createdDate: '', submissionBy: '', submissionDate: '', status: '', previousReportId: null, isClosed: false, isNearestThousand: false, templateVersion: null, sheetType: 'rpk'},
				companies: [] as any[],
				currencies: [] as any[],
				previousReports: [] as any[],
				selectedReport: null as any,
				purposes: [] as any[],
				isPageLoading: false,
				isLoading: false,
				isCompanyLoading: false,
				isDeleting: false,
				isImporting: false,
				isExporting: false,
				isCalculating: false,
				isRPKLoaded: false,
				loadedInFileId: '',
				isContainsError: true,
				dialog: {identifier: null, companyName: null as any, companyId: null as any, balanceSheetDate: null as any, currencyCode: null as any, purpose: null as any, id: 0.0, templateIndex: 0, status: '', visible: false, loading: false, isUnsaved: false, isConsolidated: false, companyReportSheets: null as any},
				dialogRemark: {identifier: null, visible: false, loading: false, message: "", type: '', icon: '', remarks: '', withRemarks: true, isOptionalRemarks: false, consoGroup: null as any, status: ''}, 
				companyReportSheet: {identifier: null, sheet: {identifier: null}, content: {template: null}},
				companyReportHistory: {identifier: null, status: '', remarks: '', createdBy: '', createdDate: ''},
				isShowConfirmation: false,
				isShowUnsavedConfirmation: false,
				isShowGlobalFilterConfirmation: false,
				isPassGlobalFilter: false,
				isRefreshNeeded: false,
				isNearestThousandPreview: false,
				unsavedId: 0.0,
				isShowImportErrorNotification: false,
				importFileName: '',
				importErrors: [] as any[],
				importDownloadMessages: '',
				importMaxFileSize: 20 * 1024 * 1024,
				selectedGlobalFilterName: ''
			}
		},
		props:{
			created:{
				type: Boolean
			}
		},
		watch: {
            filterLegalGroup(newValue: any) {
                this.load();
            },
			filterLegalGroupId(newValue: any) {
				if (this.identifier == null) {
					this.isCompanyLoading = true;
					companyApi.companyList({isRpk: true, isSheetDialog: true}, newValue)
						.then(response => {
							this.companyReport.company.identifier = null;
							this.companies = response.data.listSet;
							this.isCompanyLoading = false;
						})
						.catch(error => {
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							this.isCompanyLoading = false;
						})
				}
				
				else {
					this.triggerInterCompanySheetDialog();
				}
			}
		},
		mounted: function () {
            if (this.pageError == '') {
                this.load();
            }
		},
		computed: {
			filterLegalGroup() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel : null);
			},
			filterLegalGroupId() {
				return store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null;
			},
		},
		methods: {
			load() {
				this.isPageLoading = true;

				let r1 = companyApi.companyList({isRpk: true, isSheetDialog: true}, this.filterLegalGroupId);

				let r2 = currencyApi.currencyList({});

				let r3 = purposeApi.purposeList({});

				let r4 = null;
				let r5 = null;
				let r6 = null;

				if (this.identifier != null) {
					r4 = companyReportApi.companyReportView(this.identifier, 'rpk')
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})

					r5 = companyReportHistoryApi.companyReportHistoryViewLast(this.identifier);
					r6 = companyReportApi.companyReportCheckLoaded(this.identifier, 'rpk');
				}

				Promise.all([r1, r2, r3, r4, r5, r6])
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == 0) {
												this.companies = values[i].data.listSet;
											}

											else if (i == 1) {
												this.currencies = values[i].data.listSet;

												if (this.identifier == null) {
													this.filterCurrencyByDefaultCode('MYR');
												}
											}

											else if (i == 2) {
												this.purposes = values[i].data.listSet;
											}

											else if (i == 3) {
												this.companyReport = values[i].data.companyReport;
												if (this.companyReport != null) {	
													if (this.companyReport.balanceSheetDate != null){
														this.companyReport.balanceSheetDate = this.formatToDate(this.companyReport.balanceSheetDate);
													}
													if (this.companyReport.submissionDate != null && this.companyReport.submissionDate != '') {
														this.companyReport.submissionDate = this.formatToDateTime(this.companyReport.submissionDate);
													}
													if (this.companyReport.purpose == null) {
														this.companyReport.purpose = {'identifier': null, 'name': ""};
													}
													if(this.companyReport.isPreviousConsolidated != null){
														this.companyReport.isConsolidated = this.companyReport.isPreviousConsolidated;
													}
													this.triggerInterCompanySheetDialog();
													this.triggerSheetDialog();
												}
												this.checkCoverError();
												if (this.$store.getters.getSelectedRpkId != null) {
													this.$store.dispatch('clearSelectedRpkId');
													this.isRefreshNeeded = true;
                                                    this.checkUnsaved(1);
												}
											}
											
											else if (i == 4) {
												this.companyReportHistory = values[i].data.companyReportHistory;
												if (this.companyReportHistory != null && this.companyReportHistory.createdDate != null){
													this.companyReportHistory.createdDate = this.formatToDateTime(this.companyReportHistory.createdDate);
												}
											}

											else if (i == 5) {
												this.isRPKLoaded = values[i].data.isLoaded;
												this.loadedInFileId = values[i].data.loadedIn;
											}
										}
									}
								}
							}
							
							if (this.identifier != null && this.created){
								this.sheets(1, false, null);
							}
						}
						this.isPageLoading = false;
					})
					.catch(error => {
						this.isPageLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
				this.getGlobalFilterName();
			},
			getGlobalFilterName() {
				var selectedGlobalFilterId = this.filterLegalGroupId;
				var globalLegal = store.getters.getFilterLegalGroupModel;
				this.selectedGlobalFilterName = (globalLegal != null && globalLegal.identifier == selectedGlobalFilterId) ? globalLegal.name : null;
			},
			triggerInterCompanySheetDialog() {
				(this.$refs.sheetDialog as any)?.refreshInterCompanyDropdown(this.filterLegalGroupId, this.companyReport.company.identifier);
			},
			triggerSheetDialog() {
				(this.$refs.sheetDialog as any)?.refreshDropdown(this.filterLegalGroupId);
			},
			filterCompanyCodeByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.identifier == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].code;
				}
				return null;
			},
			filterCompanyNameByValue: function (value: any) {
				var companies = this.companies.filter(function (company: any) {
					if (company.identifier == value) {
						return company;
					}
				});
				if (companies != null && companies.length > 0) {
					return companies[0].name;
				}
				return null;
			},
			showSaveConfirmationDialog() {
				this.isLoading = true;
				
				this.previousReports = [] as any[];
				this.companyReport.balanceSheetDate = this.formatToDate(this.companyReport.balanceSheetDate);
				companyReportApi.companyReportListByPreviousCompanyReport({companyReport: this.companyReport}, 'rpk')
					.then((response: any) => {
						this.isLoading = false;
						if (response.data.listSet.length != 0) {
							this.previousReports = response.data.listSet;
							this.isLoading = false;
							
							this.isShowConfirmation = true;
						}
						
						else {
							this.isShowConfirmation = false;
							this.save(false);
						}
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			save(isPreviousReport: boolean) {
				this.isShowConfirmation = false;
				
				this.isLoading = true;
				
				if (this.companyReport.balanceSheetDate != null && (this.companyReport.balanceSheetDate instanceof Date)) {
					this.companyReport.balanceSheetDate = this.formatToDate(this.companyReport.balanceSheetDate);
				}
				
				this.companyReport.previousReportId = (isPreviousReport == true ? this.selectedReport.identifier : null)
				this.companyReport.isPreviousConsolidated = (isPreviousReport == true ? this.selectedReport.isConsolidated : null)
				
				companyReportApi.companyReportSave({companyReport: this.companyReport}, 'rpk')
					.then(response => {
						store.getters.getCached.page = null;
						this.companyReport = response.data.companyReport;
						if (this.companyReport.purpose == null) {
							this.companyReport.purpose = {'identifier': null, 'name': ""};
						}
						
						if (this.companyReport.identifier != null) {
							this.identifier = this.companyReport.identifier;
							this.isLoading = false;
							
							this.$router.push({path: "/companyreport/rpk/view/" + this.identifier, query: ({created: 'true'})});
							this.companyReport.isConsolidated = (this.companyReport.isPreviousConsolidated != null ? this.companyReport.isPreviousConsolidated : this.companyReport.isConsolidated)							
						}						
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				companyReportApi.companyReportUpdate({companyReport: this.companyReport}, 'rpk')
					.then((response: any) => {
						store.getters.getCached.page = null;
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			submit() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to submit this company report?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;
						const m = this.checkCoverError();
						if (this.isContainsError == false){
							companyReportApi.companyReportSubmit({companyReport: this.companyReport, identifier: this.identifier, templateIndex: 1}, 'rpk')
							.then(response => {
								store.getters.getCached.page = null;
								this.isLoading = false;
								this.$router.push("/companyreport/rpk");
							})
							.catch(error => {
								this.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
						} else {
							this.isLoading = false;
							this.$toast.add({severity: "error", summary: "Error", detail: 'Could not submit. Error found in Cover sheet.', life: 6000});
						}					
					}
				});
			},
            approve(selectedRPK: any, type: string) {
                this.dialogRemark.identifier = selectedRPK.identifier;
                this.dialogRemark.type = type;
                this.dialogRemark.remarks = '';
                this.dialogRemark.message = "Are you sure you want to accept this application?";
                this.dialogRemark.icon = "pi pi-check";
                this.dialogRemark.withRemarks = true;
                this.dialogRemark.isOptionalRemarks = true;
                this.dialogRemark.status = "Accepted";
                this.dialogRemark.visible = true;
            },
			reject(selectedRPK: any, type: string) {
                this.dialogRemark.identifier = selectedRPK.identifier;
                this.dialogRemark.type = type;
                this.dialogRemark.remarks = '';
                this.dialogRemark.message = "Are you sure you want to reject this application?";
                this.dialogRemark.icon = "pi pi-times";
                this.dialogRemark.withRemarks = true;
                this.dialogRemark.isOptionalRemarks = false;
                this.dialogRemark.status = "Rejected";
                this.dialogRemark.visible = true;
            },
			onConfirmDialogRemark() {
                this.dialogRemark.loading = true;
				let result = [] as any[];
                approvalApi.approvalCompanyReportUpdateStatus(this.dialogRemark.identifier, this.dialogRemark)
                    .then((response: any) => {
						if (this.dialogRemark.status == "Rejected") {
							companyReportSheetTemplateApi.companyReportSheetTemplateViewComments(this.companyReport.sheetType, this.dialogRemark.identifier, 1, {})
								.then(response2 => {
									if (response2) {
										this.companyReportSheets = response2.data.companyReportSheets;
									}
									this.companyReportSheets.forEach((companyReportSheet: any) => {
										if (companyReportSheet.sheetComments.length > 0) {
											result.push([companyReportSheet.title.sheet + " ID:" + companyReportSheet.title.id]);
											result.push(['', 'Comments', 'Last Modified By', 'Time'])
											companyReportSheet.sheetComments.forEach((sheetComment: any) => {
												result.push([
													sheetComment.cell,
													this.getCommentValue(sheetComment.comment),
													this.getCommentUsername(sheetComment.comment),
													this.getCommentTime(sheetComment.comment)
												]);
											});
											result.push([]);
											result.push([]);
											result.push([]);
										}
									});
									let filename = "_" + this.companyReport.fileId + "_comments" + ".xlsx";
					
									if (result.length > 0){
										this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});
										this.downloadExcelFileWithArray(result, filename);
									}
								})
								.catch(error => {
									this.$toast.add({ severity: "error", summary: "Error", detail: error, life: 6000});
								});
						}
						this.dialogRemark.loading = false;
                        this.dialogRemark.visible = false;
                        this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
						this.backPreviousPage();
                    })
                    .catch((error) => {
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                        this.dialogRemark.loading = false;
                    })
            },
			backPreviousPage() {
				const state = window.history.state as any
				if (state?.back) {
					this.$router.back()
				} else if (state?.from) {
					this.$router.replace(state.from)
				} else {
					this.$router.replace({ name: 'Home' })
				}
			},
            getCommentValue(comment: any) {
                if (comment == null) {
                    return '';
                }
                if (typeof comment === 'string') {
                    return comment;
                }
                return comment.value ?? '';
            },
            getCommentUsername(comment: any) {
                if (comment == null || typeof comment === 'string') {
                    return '';
                }
                return comment.lastModifiedBy ?? '';
            },
            getCommentTime(comment: any) {
                if (comment == null || typeof comment === 'string') {
                    return '';
                }
                return comment.time ?? '';
            },
            closeDialogRemark() {
                this.dialogRemark.visible = false;
            },
			deleteCompanyReport() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this RPK?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isExporting = true;
						this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});
						companyReportApi.companyReportExport({identifier: this.identifier, templateIndex: 1, actionType: "backup", backupAction: "DEL"}, 'rpk')
							.then((response: any) => {
								this.isExporting = false;
								this.isDeleting = true;
								companyReportApi.companyReportDelete({companyReport: this.companyReport, identifier: this.identifier}, 'rpk')
									.then((response: any) => {
										store.getters.getCached.page = null;
										this.isDeleting = false;
										this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
										this.$router.push("/companyreport/rpk");
									})
									.catch(error => {
										this.isDeleting = false;
										this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
									})
							})
							.catch(error => {
								this.isExporting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							});
						
					}
				})
			},
			// Validates the picked file before anything is uploaded, so obvious problems are
			// reported straight away instead of coming back as a generic server error.
			validateImportFile(selectedFile: any) {
				if (selectedFile == null) {
					return "No file was selected. Please choose the exported .csv file to import.";
				}
				if (!String(selectedFile.name).toLowerCase().endsWith(".csv")) {
					return "Only .csv files can be imported. \"" + selectedFile.name + "\" is not a .csv file. Export the report first, update the exported file, then import it back.";
				}
				if (selectedFile.size === 0) {
					return "\"" + selectedFile.name + "\" is empty (0 KB). Please select the exported file that contains the report data.";
				}
				if (selectedFile.size > this.importMaxFileSize) {
					return "\"" + selectedFile.name + "\" is " + Math.round(selectedFile.size / 1048576) + " MB, which exceeds the " + Math.round(this.importMaxFileSize / 1048576) + " MB import limit.";
				}
				return null;
			},
			// Turns the backend/transport error into something a report preparer can act on.
			// The server replies with either a known "Could not import ... Error: <reason>." message
			// or, for an unhandled exception, the raw Python exception line - which must never be
			// shown as-is.
			resolveImportErrorMessage(error: any, stage: string) {
				const detail = (typeof error === "string" ? error : (error && error.message ? error.message : "")).trim();

				if (detail.indexOf("Invalid File Type") != -1) {
					return "The file is not a supported import file. Only .csv files exported from this RPK report can be imported.";
				}
				if (detail.indexOf("Invalid Columns") != -1) {
					return "\"" + this.importFileName + "\" is missing required columns. The import file must keep the exported columns: Sheet No., Sheet Code, Row, Column, Value and Label.";
				}
				if (detail.indexOf("Invalid Argument") != -1) {
					return "The server did not receive the file. Please select \"" + this.importFileName + "\" again and retry.";
				}
				if (detail.indexOf("UnicodeDecodeError") != -1 || detail.indexOf("codec can't decode") != -1) {
					return "\"" + this.importFileName + "\" contains characters the server could not read. Re-save the file as CSV UTF-8 (in Excel: File > Save As > \"CSV UTF-8 (Comma delimited)\") and import again.";
				}
				// Raw Python exception text, e.g. "KeyError: 'Sheet No.'" or "IndexError: list index out of range".
				if (/^[A-Za-z.]*(Error|Exception)\s*:/.test(detail)) {
					return "The server could not process \"" + this.importFileName + "\" - a row in the file does not match the current report layout. Please re-export the report, re-apply your changes and import again. (Technical detail: " + detail.split("\n")[0] + ")";
				}
				if (detail != "") {
					return detail;
				}
				return stage == "backup"
					? "The backup could not be created, so the import was not started. Your report data is unchanged."
					: "The import could not be completed. Your report data may be partially updated - please review the sheets or restore the backup file.";
			},
			importFile(file: any) {
				const selectedFile = (file != null && file.length > 0) ? file[0] : null;

				const validationMessage = this.validateImportFile(selectedFile);
				if (validationMessage != null) {
					this.$toast.add({severity: "warn", summary: "Invalid Import File", detail: validationMessage, life: 10000});
					return;
				}

				this.isExporting = true;
				this.isImporting = true;
				this.importFileName = selectedFile.name;
				this.importDownloadMessages = '';
				this.importErrors = [];

				companyReportApi.companyReportExport({identifier: this.identifier, templateIndex: 1, actionType: "backup", backupAction: "IMP"}, 'rpk')
					.then(response => {
                        this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});

						this.isExporting = false;

						var formData = new FormData();
						formData.append('file', selectedFile);
						companyReportApi.companyReportImport(formData, this.identifier, 'rpk')
							.then((response: any) => {
								this.isImporting = false;

								try {
									this.$toast.add({severity: "success", summary: "Success", detail: (response && response.message) ? response.message : "Company report imported successfully.", life: 6000});

									// A fresh import replaces the sheet data, so the report is no longer in the
									// nearest-thousand converted state. Reset the flag on every successful import (even
									// when there are import messages) so the "Convert" button re-enables.
									this.companyReport.isNearestThousand = false;
									companyReportApi.companyReportUpdateIsNearestThousand({companyReport: this.companyReport}, 'rpk', this.dialog.templateIndex)
										.catch(error => {
											this.$toast.add({severity: "warn", summary: "Warning", detail: "The report was imported, but the nearest thousand status could not be reset: " + this.resolveImportErrorMessage(error, "import"), life: 10000});
										});

									const listSet = (response && response.data && Array.isArray(response.data.listSet)) ? response.data.listSet : [];
									if (listSet.length > 0) {
										this.importFileName = listSet[0].fileName || this.importFileName;
										for (let i = 0; i < listSet.length; i++) {
											this.importErrors[i] = listSet[i];
											this.importDownloadMessages += " Sheet: " + this.importErrors[i].sheetName + ". " + this.importErrors[i].errorMessage + "\n";
										}
										this.isShowImportErrorNotification = true;
									} else {
										this.isShowImportErrorNotification = false;
										this.calculate(1);
									}
								} catch (error: any) {
									// The upload itself succeeded; only the post-processing of the response failed.
									this.$toast.add({severity: "error", summary: "Import Completed With Errors", detail: "\"" + this.importFileName + "\" was uploaded, but the result could not be displayed: " + (error && error.message ? error.message : error) + ". Please recalculate and review the sheets.", life: 12000});
								}
							})
							.catch(error => {
								this.isImporting = false;
								this.$toast.add({severity: "error", summary: "Import Failed", detail: this.resolveImportErrorMessage(error, "import"), life: 12000});
							});
					})
					.catch(error => {
						this.isImporting = false;
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Backup Failed - Import Cancelled", detail: this.resolveImportErrorMessage(error, "backup"), life: 12000});
					})

			},
			loadSheetWithImportFile() {
				this.isShowImportErrorNotification = false;
				this.calculate(1);
			},
			downloadImportError() {
				this.isShowImportErrorNotification = false;
				this.downloadTextFile(this.importDownloadMessages,  "_Error" + this.importFileName.substring(0, (this.importFileName.length - 4)));
				this.calculate(1);
			},
			exportFile() {
				this.isExporting = true;
				companyReportApi.companyReportExport({identifier: this.identifier, templateIndex: 1, actionType: "manual"}, 'rpk')
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			checkUnsaved(templateIndex: any) {
				if (this.filterLegalGroupId != null && this.filterLegalGroupId != '' && this.isPassGlobalFilter == false) {
					this.isShowGlobalFilterConfirmation = true;
					return;
				}
				this.isPassGlobalFilter = false;
				companyReportApi.companyReportCheckUnsaved(this.companyReport.identifier, 'rpk', templateIndex)
					.then(response => {
							this.unsavedId = response.data.unsavedId;
							this.dialog.templateIndex = templateIndex;
							response.data.hasUnsaved ? this.isShowUnsavedConfirmation = true : this.sheets(templateIndex, false, null);
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			checkCoverError(){
				companyReportApi.companyReportCheckError({companyReport: this.companyReport, identifier: this.identifier}, 'rpk')
					.then((response: any) => {
						this.isContainsError = response.data.isContainsError;
						})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			sheets(templateIndex: any, getUnsaved: any, companyReportSheets: any) {
				getUnsaved ? this.dialog.isUnsaved = true :this.dialog.isUnsaved = false;
				this.isShowUnsavedConfirmation = false;

				this.dialog.identifier = this.companyReport.identifier;
				this.dialog.companyName = this.companyReport.company.name;
				this.dialog.companyId = this.companyReport.company.identifier;
				this.dialog.balanceSheetDate = this.companyReport.balanceSheetDate;
				this.dialog.currencyCode = this.companyReport.currency.code;
				this.dialog.purpose = this.companyReport.purpose.name;
				this.dialog.isConsolidated = this.companyReport.isConsolidated
				this.dialog.templateIndex = templateIndex;
				this.dialog.isUnsaved ? this.dialog.id = this.unsavedId : this.dialog.id = this.companyReport.id;
				this.dialog.status = this.companyReport.status;
				this.dialog.companyReportSheets = companyReportSheets;
				this.dialog.visible = true;

				document.body.classList.add("dialog-open");
			},
			updateSheets(companyReportSheets: any, isCloseDialog: any, isNearestThousand: any) {
				this.dialog.loading = true;

                if (isNearestThousand != null) {
                    this.companyReport.isNearestThousand = isNearestThousand;
					companyReportApi.companyReportUpdateIsNearestThousand({companyReport: this.companyReport}, 'rpk', this.dialog.templateIndex);
                }

				let rs = [] as any[];

				companyReportSheets.forEach((companyReportSheet: any, index: any) => {
					if (companyReportSheet.sheetError == '') {
						if (companyReportSheet.template != undefined) {
							this.companyReportSheet.identifier = companyReportSheet.identifier;
							this.companyReportSheet.sheet = companyReportSheet.sheet;
							this.companyReportSheet.content.template = companyReportSheet.template;
							let r = companyReportSheetApi.companyReportSheetUpdate({identifier: this.identifier, companyReportSheet: this.companyReportSheet}, this.dialog.templateIndex)
								.catch(error => {
									this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
								})
							rs.push(r);
						}		
					}
				});

				let r1 = companyReportApi.companyReportUpdateId({companyReport: this.companyReport}, 'rpk', this.dialog.templateIndex);
				rs.push(r1);

				Promise.all(rs)
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == values.length - 1) {
												this.companyReport.id = values[i].data.companyReport.id;
												this.dialog.id = this.companyReport.id;
											}
										}
									}
								}
							}
						}
						this.dialog.loading = false;
						this.checkCoverError();
						
						if (isCloseDialog) {
							this.closeDialog(true, null, null, null, null);
						}
					})
					.catch(error => {
						this.dialog.loading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			updateSheetCached(companyReportSheet: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any) {
				var companyReportSheetCached = {identifier: null, sheet: {identifier: null}, content: {template: null}, pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
				companyReportSheetCached.identifier = companyReportSheet.identifier;
				companyReportSheetCached.sheet = companyReportSheet.sheet;
				companyReportSheetCached.content.template = companyReportSheet.template;
				companyReportSheetCached.pageIndex = pageIndex;
				companyReportSheetCached.scrollDetail.scrollTop = scrollTop;
				companyReportSheetCached.scrollDetail.scrollLeft = scrollLeft;
				companyReportSheetCached.lastAccessedCell = lastAccessedCell;
					
				companyReportSheetApi.companyReportSheetUpdateCached({identifier: this.identifier, companyReportSheet: companyReportSheetCached}, this.dialog.templateIndex)
					.then(response => {
						//
					})
					.catch(error => {
						//
					})
			},
			deleteSheetCached(companyReportSheet: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any, isCloseDialog: any) {
				this.dialog.loading = true;
				
				var companyReportSheetCached = {identifier: null, pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
				companyReportSheetCached.identifier = companyReportSheet.identifier;
				companyReportSheetCached.pageIndex = pageIndex;
				companyReportSheetCached.scrollDetail.scrollTop = scrollTop;
				companyReportSheetCached.scrollDetail.scrollLeft = scrollLeft;
				companyReportSheetCached.lastAccessedCell = lastAccessedCell;
				
				companyReportSheetApi.companyReportSheetDeleteCached({identifier: this.identifier, companyReportSheet: companyReportSheetCached}, this.dialog.templateIndex)
					.then(response => {
						this.dialog.loading = false;
						
						if (isCloseDialog) {
							this.closeDialog(true, companyReportSheetCached.pageIndex, companyReportSheetCached.scrollDetail.scrollTop, companyReportSheetCached.scrollDetail.scrollLeft, companyReportSheetCached.lastAccessedCell);
						}
					})
					.catch(error => {
						this.dialog.loading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			closeDialog(hasCached: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any) {
				if (!hasCached) {
					var lastAccessedDetail = {pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
					lastAccessedDetail.pageIndex = pageIndex;
					lastAccessedDetail.scrollDetail.scrollTop = scrollTop;
					lastAccessedDetail.scrollDetail.scrollLeft = scrollLeft;
					lastAccessedDetail.lastAccessedCell = lastAccessedCell;
					
					companyReportApi.companyReportLastAccess({identifier: this.identifier, lastAccessedDetail: lastAccessedDetail}, 'rpk', this.dialog.templateIndex)
						.then(response => {
							//
						})
						.catch(error => {
							//
						})
				}
				this.dialog.companyReportSheets = null;
				this.dialog.visible = false;
				this.isNearestThousandPreview = false;
				document.body.classList.remove("dialog-open");
				if (this.isRefreshNeeded) {
					this.isRefreshNeeded = false;
					window.location.reload();
				}
			},
			calculate(templateIndex: any, isNearestThousandPreview: any = false) {
				this.isCalculating = true;

				companyReportSheetApi.companyReportSheetViewByCompanyReportId(this.identifier, 'rpk', templateIndex)
					.then(response => {
						this.companyReportSheets = response.data.listSet;

						let r = [] as any[];
						this.companyReportSheets.forEach((companyReportSheet: any, index: any) => {
							companyReportSheet.sheetError = '';
							// For a nearest-thousand preview, read the staged (unsaved) converted draft rather than
							// the persisted data, so we recompute formulas from the converted numbers below.
							r.push(companyReportSheetTemplateApi.companyReportSheetTemplateViewByCompanyReportSheet(templateIndex, companyReportSheet.identifier, {identifier: this.identifier, isUnsaved: isNearestThousandPreview})
								.catch(error => {
									companyReportSheet.sheetError = error;
								}));
						});

						Promise.all(r)
							.then((values: any) => {
								if (values != null) {
									for (var i = 0; i < values.length; i++) {
										if (values[i] != null && values[i].data != null) {
											this.companyReportSheets[i].template = values[i].data.content.template;

											this.companyReportSheets[i].navigateChilds = [];
											if (values[i].data.function != null && values[i].data.function.navigateChilds != null) {
												this.companyReportSheets[i].navigateChilds = values[i].data.function.navigateChilds;
											}

											this.setComponents(this.companyReportSheets, i, false);
										}
									}

									for (var j = 0; j < values.length; j++) {
										if (values[j] != null && values[j].data != null) {
											this.setValues(this.companyReportSheets, j, 'rpk', false);
										}
									}

									if (templateIndex == 1) {
										this.isCalculating = false;

										if (isNearestThousandPreview) {
											// The conversion nulls FORMULA cells, recomputed above via setValues. Write the
											// recomputed values into the unsaved draft (cache) so the draft is complete, then
											// open sheet mode on the draft with reportSheets = null. The null path loads the
											// draft from cache without auto-saving (the reportSheets != null path auto-persists
											// on open), letting the user review and then Save (persist + mark converted) or
											// discard to keep the original data.
											var stagePromises = this.companyReportSheets.map((companyReportSheet: any) => {
												var companyReportSheetCached = {identifier: companyReportSheet.identifier, sheet: companyReportSheet.sheet, content: {template: companyReportSheet.template}, pageIndex: null, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
												return companyReportSheetApi.companyReportSheetUpdateCached({identifier: this.identifier, companyReportSheet: companyReportSheetCached}, templateIndex);
											});
											Promise.all(stagePromises)
												.then(() => {
													this.sheets(1, true, null);
												})
												.catch((error: any) => {
													this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
												});
										}

										else {
											this.sheets(1, false, this.companyReportSheets);
										}
									}
								}
							})
							.catch(error => {
								console.log(error)
								this.isCalculating = false;
							})
					})
					.catch((error: any) => {
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						this.isCalculating = false;
					})
			},
			cancel() {
				this.$router.push("/companyreport/rpk");
			},
			filterCurrencyByDefaultCode: function (code: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.code == code) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return this.companyReport.currency.identifier = currencies[0].identifier;
				}
			},
			filterCurrencyCodeByValue: function (value: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.identifier == value) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return currencies[0].code;
				}
				return null;
			},
			filterCurrencyNameByValue: function (value: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.identifier == value) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return currencies[0].name;
				}
				return null;
			},
			onCompanyChange() {
				if (this.companyReport.company.identifier != null) {
					var companies = this.companies.filter((company: any) => company.identifier == this.companyReport.company.identifier);
					if (companies != null && companies.length > 0 && companies[0].currency != null) {
						this.filterCurrencyByDefaultCode(companies[0].currency);
					}

					else {
						this.filterCurrencyByDefaultCode('MYR');
					}
				}
				
				else {
					this.filterCurrencyByDefaultCode('MYR');
				}
			},
			nearestThousandConversion(companyReport: any) {
				if (this.isContainsError){
					this.$toast.add({severity: "error", summary: "Error", detail: 'Could not convert. Error found in Cover sheet.', life: 6000});
					return;
				}

                this.isExporting = true;
                this.isImporting = true;

                companyReportApi.companyReportExport({identifier: companyReport.identifier, templateIndex: 1, actionType: "backup", backupAction: "NTH"}, 'rpk')
					.then(response => {
                        this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});
                        this.isExporting = false;
                        companyReportApi.companyReportNearestThousand({companyReport: companyReport, identifier: companyReport.identifier})
                            .then((response: any) => {
                                this.isImporting = false;
                                // The conversion is now staged as an unsaved draft (not persisted). Recompute and
                                // open sheet mode on that draft so the user can review the converted values and
                                // either Save (persist + mark as nearest-thousand) or discard to keep the original.
                                this.unsavedId = response.data != null && response.data.unsavedId != null ? response.data.unsavedId : this.unsavedId;
                                this.isNearestThousandPreview = true;
                                this.calculate(1, true);
                            })
                            .catch((error: any) => {
                                this.isImporting = false;
                                this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                            })
					})
					.catch(error => {
                        this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
                
            },
			showSheetsCommentsDialog() {
				(this.$refs.sheetsCommentsDialog as any).showDialog('rpk', 1, this.companyReport);
			},
            proceedWithResetGlobalFilter() {
                this.isShowGlobalFilterConfirmation = false;
                this.isPassGlobalFilter = true; 
                this.$store.dispatch('updateSelectedRpkId', this.companyReport.identifier);
				this.$store.dispatch('filterLegalGroupModelSession', null);
            },
            proceedGlobalFilterWarning() {
                this.isPassGlobalFilter = true; 
                this.isShowGlobalFilterConfirmation = false; 
                this.checkUnsaved(1);                
            }
		},
		setup() {
			return {v$: useVuelidate()}
		},
		validations() {
			return {
				companyReport: {
					company: {
						identifier: {
							required
						},
					},
					balanceSheetDate: {
						required
					},
					currency: {
						identifier: {
							required
						},
					},
					purpose: {
						identifier: {
							required
						},
					},
					isClosed: {
						required
					},
				},
				selectedReport: {
					required: requiredIf(this.isShowConfirmation),
				}
			}
		}
	});
</script>
